
import {Azienda} from '../models/azienda';
import {Tipocommessa} from '../models/tipocommessa';
import {Statocommessa} from '../models/statocommessa';

export class Commessa {
    Codice: number;         //
    Numerocommessa: number; //
  //Cliente
    Codiceazienda: number;
    Nomecliente: string; //
    Nomestato: string;
  //Veicolo
    Marcaveicolo: string; //
    Modelloveicolo: string;
    Targaveicolo: string;
    Telaioveicolo: String; //
  //Frigo
    Marcafrigo: string; //
    Matricolafrigo: string; //
    Modellofrigo: string; //
    Annofabbricazionefrigo: string; //
  // Anomalie riferite dal cliente
    Note: string;
  // Diagnosi officina
    Noteofficina: string; //

    Statocommessa: Statocommessa; //

    Dataingresso:Date;
    Datafine:Date;
    Codicetipolavorazione: number;

    Azienda:Azienda;
    Tipocommessa: Tipocommessa;

    Codiceassegnatario: number;
    Nomeassegnatario: string;
    Cognomeassegnatario: string;
    Tot: string;
    Eng: string;
    Ele: string;

  constructor(){
    this.Codice=0;
    this.Numerocommessa=0;
    this.Nomecliente='';
    this.Nomestato='';
    this.Dataingresso=new Date();
    this.Datafine=new Date();
    this.Marcaveicolo='';
    this.Modelloveicolo='';
    this.Targaveicolo='';
    this.Telaioveicolo='';
    this.Marcafrigo='';
    this.Matricolafrigo='';
    this.Modellofrigo='';
    this.Annofabbricazionefrigo='';
    this.Codicetipolavorazione=0;
    this.Codiceazienda=0;
    this.Note='';
    this.Noteofficina='';
    this.Azienda=new Azienda();
    this.Statocommessa=new Statocommessa();
    this.Tipocommessa=new Tipocommessa();
    this.Codiceassegnatario=0;
    this.Nomeassegnatario='';
    this.Cognomeassegnatario='';
    this.Tot='';
    this.Eng='';
    this.Ele='';
  }
}
